(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("5saJz", function(module, exports) {
var $3f87e4cda1c1e920$var$printButton = document.querySelector(".s-product-detail-info__print");
var $3f87e4cda1c1e920$var$SetContentHeight = function(content, contentBlockEnd) {
    var offsetHeight = contentBlockEnd.offsetHeight;
    var offsetTop = contentBlockEnd.offsetTop;
    var height = offsetHeight + offsetTop + 64 + 52; //first title after last visible block
    content.style.height = height + "px";
};
$3f87e4cda1c1e920$var$printButton === null || $3f87e4cda1c1e920$var$printButton === void 0 || $3f87e4cda1c1e920$var$printButton.addEventListener("click", function() {
    window.print();
});
var $3f87e4cda1c1e920$var$contents = document.querySelectorAll(".s-product-detail-info__top");
$3f87e4cda1c1e920$var$contents.forEach(function(content) {
    var _a;
    var contentBlocks = content.querySelectorAll(".s-product-detail-info__top-block");
    var contentBlockEnd = content.querySelector(".s-product-detail-info__top-block.--show-more-end");
    var openButton = content.querySelector(".s-product-detail-info__more");
    if (!contentBlockEnd) {
        openButton === null || openButton === void 0 || openButton.classList.add("--hidden");
        (_a = content.closest(".s-product-detail-info")) === null || _a === void 0 || _a.classList.remove("--bottom-line");
        return;
    }
    $3f87e4cda1c1e920$var$SetContentHeight(content, contentBlockEnd);
    openButton === null || openButton === void 0 || openButton.addEventListener("click", function() {
        openButton.classList.toggle("--open");
        content.classList.toggle("--open");
        if (content.classList.contains("--open")) content.style.height = "auto";
        else $3f87e4cda1c1e920$var$SetContentHeight(content, contentBlockEnd);
    });
    var windowWidth = window.innerWidth;
    window.addEventListener("resize", function() {
        if (window.innerWidth != windowWidth) {
            windowWidth = window.innerWidth;
            $3f87e4cda1c1e920$var$SetContentHeight(content, contentBlocks);
        }
    });
});

});

})();
//# sourceMappingURL=product-detail-info-section.47377378.js.map
